<template>
    <div class="navigation-drawer__navlist-item">
        <v-list-tile
                class="navigation-drawer__navlist-tile"
                @click="clickMenuItem"
                @mouseenter.native="mouseOverMenu($event)"
                @mouseleave.native="mouseOffMenu($event)"
        >
            <v-list-tile-title>
                <v-icon :class="iconColor">
                    {{ menuItem.icon }}
                </v-icon>
                <h3 class="body-2" :class="iconColor">
                    {{ menuItem.label }}
                </h3>
                <v-icon v-if="hasChildren" :class="iconColor">
                    keyboard_arrow_right
                </v-icon>
            </v-list-tile-title>
        </v-list-tile>
        <!-- Begin: Was Outer -->
        <v-menu v-if="hasChildren && drawOpenUi"
                :open-on-click="false"
                :open-on-hover="false"
                :close-on-click="false"
                transition="slide-y-transition"
                content-class="navigation-drawer__navlist-flyout"
                v-model="openState"
                :activator="myActivator"
                offset-x
        >
            <v-list dense ref="navigation-drawer-flyout"
                    @mouseenter.native="mouseOverMenu($event)"
                    @mouseleave.native="mouseOffMenu($event)">
                <v-list-tile v-for="child in filteredChildren(menuItem.children)"
                             :key="generateUniqueHash(child)"
                             @click="clickSubMenuItem(child)"
                >
                    <v-list-tile-title>{{ child.label }}</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
        <!-- End: Was Outer -->
    </div>
</template>


<script>
    import {mapActions, mapState, mapGetters} from 'vuex'

    export default {
        name: 'navigation-drawer-item',

        data: () => ({
            iconColor: 'grey--text text--darken-2',
            id: Date.now(),
            isMenuHovered: false,
            myActivator: null,
            openState: false,
            timer: null,
        }),

        props: [
            'menuItem',
            'isDrawerOpen'
        ],

        computed: {
            ...mapGetters({
                currentUserHasPerm: 'currentUserHasPerm'
            }),

            ...mapState({
                drawOpenUi: state => state.ui.navigationDrawer.openState
            }),
            hasChildren() {
                return (this.menuItem.children && this.menuItem.children.length)
            },

            ...mapState({
                currentUser: state => state.auth.currentUser
            })
        },

        mounted() {
            this.myActivator = this.$el.querySelector('.navigation-drawer__navlist-tile')
        },

        watch: {
            isDrawerOpen: function (isOpen) {
                if (this.isMenuHovered && isOpen) {
                    this.showSubMenu()
                } else {
                    this.hideSubMenu()
                }
            }
        },

        methods: {

            hasPermission(childItem) {
                let userPerms = this.currentUser.permissions

                if (childItem !== 'Requests') return true
                return userPerms.includes(SILA_PERMISSION_JOBS_JOB_CREATE)
            },

            filteredChildren(children) {
                const navItems = children.filter(navItem => {
                    const permission = navItem.permission

                    if (permission && permission !== '' && this.currentUserHasPerm(window[permission]) === false) {
                        return false
                    }

                    if (!this.hasPermission(navItem.label) && navItem.label === 'Requests') {
                        return false
                    }
                    return true
                })
                return navItems
            },

            clickMenuItem() {
                if (!this.hasChildren) {
                    this.$router.push({name: this.menuItem.routeName})
                    this.hideSubMenu()
                }
            },

            clickSubMenuItem(item) {
                this.hideSubMenu()
                window.setTimeout(() => {
                    this.$router.push({name: item.routeName})
                }, 750)
            },

            switchMenuIconColor(e) {
                this.iconColor = (e.type === 'mouseenter') ? 'white--text' : 'grey--text text--darken-2'
            },

            mouseOverMenu(e) {
                clearTimeout(this.timer)
                this.switchMenuIconColor(e)
                this.isMenuHovered = true
                this.$emit('menu-hover', this.id)
                this.showSubMenu()
            },

            mouseOffMenu(e) {
                clearTimeout(this.timer)
                this.timer = window.setTimeout(() => {
                    this.switchMenuIconColor(e)
                    this.isMenuHovered = false
                    this.$emit('menu-hoveroff', this.id)
                    this.hideSubMenu()
                }, 50)
            },

            showSubMenu() {
                if (this.openState === false && this.hasChildren && this.isDrawerOpen) {
                    this.styleSubMenu()
                    this.$nextTick(() => {
                        this.openState = true
                    })
                }
            },

            hideSubMenu() {
                this.openState = false
            },

            styleSubMenu() {
                let positionData = this.myActivator.getBoundingClientRect()
                let menuEl = this.$refs['navigation-drawer-flyout'].$el.parentNode
                // TODO: Figure out what the hell causes the initial attributes to differ from the second time onward, ugh
                //
                // menuEl.style.display = 'block'
                // menuEl.style.width = 'auto'
                // menuEl.style.minWidth = '0px'
                menuEl.style.left = (positionData.width - 32) + 'px'
                // menuEl.style.top = (positionData.top + 10) + 'px'
            },

        },
    }
</script>

